/**
 * 우클릭 = 클립보드 복사.
 *
 * 회장님 지침입니다. URL·제목·ID 처럼 **식별자를 가진 요소**는 우클릭으로
 * 바로 복사됩니다. 별도의 복사 버튼을 목록에 늘어놓지 않아도 되므로 행이
 * 가벼워집니다.
 *
 * 사용:
 *   <td {...copyOnRightClick(media.source_ref, 'URL')}>…</td>
 */

import type { MouseEvent } from 'react'
import { toast } from 'sonner'

export async function copyText(value: string, label = '값'): Promise<void> {
  if (!value) {
    toast.error(`복사할 ${label}이(가) 비어 있습니다.`)
    return
  }
  try {
    await navigator.clipboard.writeText(value)
    // Silent Success — 짧게만 알리고 사라집니다.
    toast.success(`${label}을(를) 복사했습니다.`, { duration: 1200 })
  } catch {
    // 클립보드 권한이 없거나 보안 컨텍스트가 아닌 경우입니다. 숨기지 않습니다.
    toast.error(
      `${label}을(를) 복사하지 못했습니다. 브라우저가 클립보드 접근을 막고 있습니다.`,
    )
  }
}

/**
 * 요소에 펼쳐 넣는 우클릭 복사 핸들러입니다.
 * 브라우저 기본 컨텍스트 메뉴는 막습니다 (Shift+우클릭이면 기본 메뉴가 뜹니다).
 */
export function copyOnRightClick(
  value: string | number | null | undefined,
  label = '값',
): { onContextMenu: (event: MouseEvent) => void; title: string } {
  const text = value === null || value === undefined ? '' : String(value)
  return {
    onContextMenu: (event: MouseEvent) => {
      if (event.shiftKey) return // 기본 메뉴를 쓰고 싶을 때의 탈출구
      event.preventDefault()
      void copyText(text, label)
    },
    title: text ? `${text}\n(우클릭하시면 복사됩니다)` : '',
  }
}
